export enum PilaResponseErrorCodes {
    PILA_SUCCESS_OPERATION = 80000,
    PILA_AUTH_ERROR = 80002,
    PILA_TAXPAYER_CREATION_FAILED = 80004,
    PILA_TAXPAYER_DATA_ERROR = 80005,
    PILA_VALIDATE_REFERENCE_NOT_FOUND = 80006,
    PILA_SPREEDSHEET_NOT_FOUND = 80011,
    PILA_INTERNAL_SERVER_ERROR = 89999,
}
